function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*global FB */
import Domodule from 'domodule';
import { findOne, on } from 'domassist';
var BASE_URLS = {
  twitter: 'https://twitter.com/intent/tweet',
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  gplus: 'https://plus.google.com/share',
  linkedin: 'https://www.linkedin.com/shareArticle'
};

var SocialShareButton = /*#__PURE__*/function (_Domodule) {
  _inherits(SocialShareButton, _Domodule);

  var _super = _createSuper(SocialShareButton);

  function SocialShareButton() {
    _classCallCheck(this, SocialShareButton);

    return _super.apply(this, arguments);
  }

  _createClass(SocialShareButton, [{
    key: "postInit",
    value: function postInit() {
      var _this = this;

      var setupMethod = "".concat(this.options.net, "Setup");
      var shareMethod = "".concat(this.options.net, "Share");

      if (!this[shareMethod] && !this[setupMethod]) {
        throw new Error("Sharing method for ".concat(this.options.net, " is not implemented"));
      }

      if (this[setupMethod]) {
        this[setupMethod]();
      }

      if (this[shareMethod]) {
        on(this.el, 'click', function (e) {
          e.preventDefault();

          _this[shareMethod]();
        });
      }
    }
  }, {
    key: "getShareUrl",
    value: function getShareUrl() {
      var url = window.location.href;

      if (this.options.baseUrl) {
        if (this.options.relative) {
          url = "".concat(window.location.origin).concat(window.location.pathname).concat(this.options.baseUrl);
        } else {
          url = this.options.baseUrl;
        }
      }

      return url;
    }
  }, {
    key: "gplusShare",
    value: function gplusShare() {
      SocialShareButton.openWindow(this.el.href, '600', '500', 'gplusWindow');
    }
  }, {
    key: "twitterShare",
    value: function twitterShare() {
      SocialShareButton.openWindow(this.el.href, '260', '500', 'twitterWindow');
    }
  }, {
    key: "linkedinShare",
    value: function linkedinShare() {
      SocialShareButton.openWindow(this.el.href, '520', '570', 'linkedinWindow');
    }
  }, {
    key: "facebookShare",
    value: function facebookShare() {
      if (typeof window.FB !== 'undefined' && typeof window.FB.ui !== 'undefined') {
        var object = {
          method: 'share',
          href: this.getShareUrl()
        };

        if (this.options.tag) {
          object.hashtag = "#".concat(this.options.tag);
        }

        if (this.options.text) {
          object.quote = this.options.text;
        }

        FB.ui(object);
      } else {
        SocialShareButton.openWindow(this.el.href, '440', '600', 'facebookWindow');
      }
    }
  }, {
    key: "facebookSetup",
    value: function facebookSetup() {
      var params = ["u=".concat(this.getShareUrl())];

      if (this.options.tag) {
        params.push("hashtag=".concat(encodeURIComponent("#".concat(this.options.tag))));
      }

      if (this.options.text) {
        params.push("quote=".concat(encodeURIComponent(this.options.text)));
      }

      this.el.href = "".concat(BASE_URLS.facebook, "?").concat(params.join('&'));
    }
  }, {
    key: "emailSetup",
    value: function emailSetup() {
      var title = encodeURIComponent(this.options.subject || document.title);
      var body = this.options.body || 'Check this out #url';
      body = body.replace(/#url/gi, this.getShareUrl());
      body = encodeURIComponent(body);
      this.el.href = "mailto:?subject=".concat(title, "&body=").concat(body);
    }
  }, {
    key: "gplusSetup",
    value: function gplusSetup() {
      this.el.href = "".concat(BASE_URLS.gplus, "?url=").concat(this.getShareUrl());
    }
  }, {
    key: "linkedinSetup",
    value: function linkedinSetup() {
      var params = ["url=".concat(encodeURIComponent(this.getShareUrl()))];
      var shareText = this.options.text;
      var shareTitle = this.options.title;

      if (shareText) {
        params.push("summary=".concat(encodeURIComponent(shareText)));
      }

      if (shareTitle) {
        params.push("title=".concat(encodeURIComponent(shareTitle)));
      }

      this.el.href = "".concat(BASE_URLS.linkedin, "?mini=true&").concat(params.join('&'));
    }
  }, {
    key: "twitterSetup",
    value: function twitterSetup() {
      var shareText = this.options.text || SocialShareButton.getTwiMeta('text');
      var shareTag = this.options.tags || SocialShareButton.getTwiMeta('hashtag');
      var shareVia = this.options.via || SocialShareButton.getTwiMeta('author');
      var params = [];
      params.push("url=".concat(encodeURIComponent(this.getShareUrl())));

      if (shareText) {
        params.push("text=".concat(encodeURIComponent(shareText)));
      }

      if (shareTag && shareTag !== 'none') {
        params.push("hashtags=".concat(encodeURIComponent(shareTag)));
      }

      if (shareVia && shareVia !== 'none') {
        params.push("via=".concat(encodeURIComponent(shareVia)));
      }

      this.el.href = "".concat(BASE_URLS.twitter, "?").concat(params.join('&'));
    }
  }, {
    key: "required",
    get: function get() {
      return {
        options: ['net']
      };
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        relative: false,
        baseUrl: false
      };
    }
  }], [{
    key: "getTwiMeta",
    value: function getTwiMeta(tag) {
      var meta = findOne("meta[property=\"twi:".concat(tag, "\"]"));
      return meta ? meta.getAttribute('content') : null;
    }
  }, {
    key: "openWindow",
    value: function openWindow(url, height, width, key) {
      window.open(url, key, "menubar=no,toolbar=no,left=200,top=200,resizable=yes,scrollbars=no,height=".concat(height, ",width=").concat(width));
    }
  }]);

  return SocialShareButton;
}(Domodule);

export { SocialShareButton as default };
Domodule.register('SocialShareButton', SocialShareButton);